export const PRIMARY_COLOR = '#6B33F9';
export const SUBJECT_TAG_COLOR = '#262626';
export const SECONDARY_COLOR = '#00A351';
export const CORRECT_COLOR = '#00A351';
export const PARTIALLY_CORRECT_COLOR = '#FFC53D';
export const INCORRECT_COLOR = '#FF4D4F';

